import { prettyFileType } from "@/modules/core/file-manager/fileManagerTS";
import filemanager from "@/modules/core/file-manager/filemanager.js";

export const fileTypeEnum = [
	{
		value: "TXT",
		label: "Text",
		desc: prettyFileType.TXT,
	},
	{
		value: "BIN",
		label: "BIN",
		desc: prettyFileType.BIN,
		isReadOnly: true,
	},
	{
		value: "EAP",
		label: "API",
		desc: prettyFileType.EAP,
	},
	// {
	// 	value: "APL",
	// 	label: "API Library",
	// 	desc: prettyFileType.APL,
	// },
	{
		value: "WSS",
		label: "WebSocket",
		desc: prettyFileType.WSS,
	},
	// {
	// 	value: "WSL",
	// 	label: "Websocket Library",
	// 	desc: prettyFileType.WSL,
	// },
	{
		value: "LIB",
		label: "Library",
		desc: prettyFileType.LIB,
	},
];

export const fileLangEnum = [
	{
		label: "JavaScript",
		value: "JavaScript",
	},
];
